import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Button, Typography } from "@mui/material";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import PageLayout from "../components/common/page-layout";
import RunDetail from "../components/doc-extraction-evals/run-detail";
import { RequireAuth } from "../hooks/use-auth";
import { ROUTES } from "../route-paths";

/** Route host for a single eval run's detail view (`/doc-extraction-evals/runs/:id`). */
const DocExtractionEvalRunPage = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  return (
    <RequireAuth>
      <PageLayout
        subtitle="New document-extraction pipeline"
        title="Doc extraction eval run"
        actions={
          <Button
            size="small"
            startIcon={<ArrowBackIcon />}
            onClick={() => {
              navigate(ROUTES.DOC_EXTRACTION_EVALS);
            }}
          >
            Back to evals
          </Button>
        }
      >
        {id === undefined ? (
          <Typography>No run id.</Typography>
        ) : (
          <RunDetail runId={id} />
        )}
      </PageLayout>
    </RequireAuth>
  );
};

export default DocExtractionEvalRunPage;
